import { IconErrorBig, IconInfoBig, IconSuccessBig, IconWarningBig } from 'assets'
import { DialogPopupTypes } from './DialogPopup.types'

export const getIconAndHeading = (type: DialogPopupTypes): {
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement> & {
    title?: string;
  }>,
  defaultHeading: string
} => {
  switch (type) {
    case DialogPopupTypes.SUCCESS: return {
      icon: IconSuccessBig,
      defaultHeading: 'Successful operation'
    }
    case DialogPopupTypes.ERROR: return {
      icon: IconErrorBig,
      defaultHeading: 'Error'
    }
    case DialogPopupTypes.INFO: return {
      icon: IconInfoBig,
      defaultHeading: 'Information'
    }
    case DialogPopupTypes.WARNING: return {
      icon: IconWarningBig,
      defaultHeading: 'Warning'
    }
    default: return {
      icon: null,
      defaultHeading: ''
    }
  }
}
